import { Trans } from "@lingui/macro";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Button from "@mui/material/Button";
import React, { useState } from "react";
import { useToggle } from "react-use";

import ClientFilterDialog, { FilerOptions } from "./ClientFilterDialog";

export interface ClientFilterButtonProps {
	onFilterChanged: (filter: FilerOptions | null) => void;
}

const ClientFilterButton = ({ onFilterChanged }: ClientFilterButtonProps) => {
	const [isOpen, toggleOpen] = useToggle(false);
	const [filter, setFilter] = useState<FilerOptions | null>(null);

	const applyFilter = (newValue: FilerOptions | null) => {
		setFilter(newValue);
		onFilterChanged(newValue);
		toggleOpen();
	};

	return (
		<>
			<Button color="primary" startIcon={<FilterAltOutlinedIcon />} onClick={toggleOpen}>
				<Trans>Filter List</Trans>
			</Button>
			<ClientFilterDialog
				isOpen={isOpen}
				onClose={toggleOpen}
				filters={filter}
				applyFilter={applyFilter}
			/>
		</>
	);
};

export default ClientFilterButton;
